import dayjs from 'dayjs';
import isDateBlocked from './isDateBlocked';

const makeUnavailableMatcher = availability => date =>
  isDateBlocked(availability[dayjs(date).format('YYYY-MM-DD')]);

export default makeUnavailableMatcher;
